<template>
  <nav class="demo-navigation mdl-navigation mdl-color--blue-grey-800">

    <a class="mdl-navigation__link" href="">
      <i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">home</i>
      {{ i18n().home }}
    </a>

    <router-link :to="{ name: 'csv-words' }" class="mdl-navigation__link">
      <i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">search</i>
      {{ i18n().csvWordsAnalyzer }}
    </router-link>

    <router-link :to="{ name: 'csv-ads' }" class="mdl-navigation__link">
      <i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">grade</i>
      {{ i18n().csvAdsAnalyzer }}
    </router-link>

    <div class="mdl-layout-spacer"></div>

    <router-link :to="{ name: 'account-settings' }" class="mdl-navigation__link">
      <i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">account_box</i>
      {{ i18n().accountSettings }}
    </router-link>

    <router-link class="mdl-navigation__link" :to="{ name: 'logout' }">
      <i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">exit_to_app</i>
      {{ i18n().logout }}
    </router-link>

    <a class="mdl-navigation__link" href="">
      <i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">help_outline</i>
      <span class="visuallyhidden">{{ i18n().help }}</span>
    </a>

  </nav>
</template>

<script>
  import i18n from "i18n"
  import api from "api"

  export default {
    name: 'left-menu',
    data () {
      return {

      }
    },
    methods: {
      i18n() { return i18n().menu }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// LeftMenu.vue?5084983a